import { createSelector } from 'reselect';
const getForm = (state, props) => {
	return state.exports.formProduct[props.name] || '';
};

export const getFormProduct = createSelector([getForm], form => form);
